import { render, staticRenderFns } from "./PostingSplitModal.vue?vue&type=template&id=66da49e0&scoped=true&"
import script from "./PostingSplitModal.vue?vue&type=script&lang=js&"
export * from "./PostingSplitModal.vue?vue&type=script&lang=js&"
import style0 from "./PostingSplitModal.vue?vue&type=style&index=0&id=66da49e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da49e0",
  null
  
)

export default component.exports